import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { LoginService } from '../../../../../../../services/login/login.service';

@Component({
  selector: 'app-form-factura',
  templateUrl: './form-factura.component.html',
  styleUrls: ['./form-factura.component.scss']
})
export class FormFacturaComponent implements OnInit {
  public formulario: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<FormFacturaComponent>,
    private loginService: LoginService,
  ) { }

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm = () => {
    const dataUser = this.loginService.getDataClientePedido();
    this.formulario = this.formBuilder.group({
      legal_name: ['', [Validators.required, Validators.minLength(3)]],
      tax_id: ['', [Validators.required, Validators.pattern('^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([A-Z]|[0-9]){2}([A]|[0-9]){1})?$'), Validators.maxLength(13)]],
      useCFDI: ['G03', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      cp: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
      predetermined: [false],
      cliente_id: [dataUser.client_number],
      empresa_id: [dataUser.almacenPre],
      correo: [dataUser.email],
      option: ['insert'],

    });
  }

  public submit = (event) => {
    event.preventDefault();
    if (this.formulario.valid) {
      ////console.log("submit form");
      ////console.log(this.formulario.value);
      this.dialogRef.close(this.formulario.value);
    } else {
      this.formulario.markAllAsTouched();
    }
  }

  // *** VALIDETE ***
  // metodos que se utilizaran para validar
  public isInValidateForm = (input: string): boolean => {
    return this.getInput(input).invalid && this.getInput(input).touched;
  }

  public isValidateForm = (input: string, length: number): boolean => {
    return this.getInput(input).valid && this.getInput(input).touched &&
      this.getInput(input).value.length > length;
  }
  
  public getInput = (input: string) => {
    return this.formulario.get(input);
  }
}
